import type { AnyGUID, StringGUID } from "../types/GUID"

import { IsString } from "../checks/IsString"

/**
 * Converts a GUID to its string representation.
 * If already a string, returns as-is. Otherwise converts bigint to base-36 string.
 *
 * @param guid - GUID as either bigint or string
 * @returns String representation in base-36 format
 *
 * @example
 * ```ts
 * import { GuidToString } from "@pdfking/tfunc"
 *
 * const guid = UUID()
 * const str = GuidToString(guid)
 * console.log(str) // Base-36 string representation
 *
 * const alreadyString = "abc123"
 * GuidToString(alreadyString) // "abc123" (unchanged)
 * ```
 */
export const GuidToString = (guid: AnyGUID): StringGUID =>
  IsString(guid) ? guid : (guid.toString(36) as StringGUID)
